import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

export interface OfferLabel {
  countdown?: {
    endDate: string;
    message: string;
    threshold: number;
  };
  message: string;
  promoCode?: string;
}

interface TrustItem {
  headerIconURL: string;
  headerText: string;
  heading: string;
  links: {
    href: string;
    text: string;
  }[];
  subHeading: string;
}

export interface ContentState {
  offerLabel?: OfferLabel;
  trustItems: TrustItem[];
}

export const initialState: ContentState = {
  trustItems: [],
};

export const { actions, reducer } = createSlice({
  name: 'content',
  initialState,
  reducers: {
    setContent: (state, { payload }: PayloadAction<ContentState>) => {
      if (payload.offerLabel) {
        state.offerLabel = payload.offerLabel;
      }

      state.trustItems = payload.trustItems;
    },
  },
});
